import { IDTOHandlebar } from '@/api/api-messenger';

export default class MessageHandlebar {
  id: number;

  name: string;

  expression: string;

  constructor(o?: IDTOHandlebar) {
    this.id = o?.handlebarId ?? 0;
    this.name = o?.name ?? '';
    this.expression = o?.expression ?? '';
  }
}
